/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { A as Alert, d as defineCustomElement$1 } from './alert.js';
const IonAlert = Alert;
const defineCustomElement = defineCustomElement$1;
export { IonAlert, defineCustomElement };